import React from 'react';
import "./home.css"
import logo from "../../../assets/images/logo.png"
import { useNavigate } from 'react-router-dom';

function Home() {
    const navigate = useNavigate();
    return (
        <div className='home-section' id='home'>
            <div className='home-ls'>
                <div className='home-title'>
                    <h1 className='home-title-text'>Welcome to <br /> Hymus Sports!</h1>
                </div>
                <div className='home-txt'>
                    <p className='home-txt-content'>
                        Hymus Sports operates one of Scarborough's largest private indoor sports complexes, with a focus on badminton. We welcome players of all ages and backgrounds, and aim to promote active lifestyles through badminton, pickleball, and more.
                    </p>
                </div>
                <div className='home-btn'>
                    {/* <a href='#booking'>Book Now</a> */}
                    {/* <a href='/register'>Join Us</a> */}
                    <button className='home-book-btn' onClick={() => navigate('/online-booking')}>
                        Book Now
                        <span className="home-beta-tag">Beta</span>
                    </button>
                    <h1 className='home-hours-txt' style={{ color: 'white', padding: '10px 5px', border: '3px solid white' }}>OPEN 24 HOURS</h1>
                </div>
            </div>
        </div>
    );
}

export default Home;